var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9743 21.8356L17.8235 15.5236C18.6412 14.0716 19.1102 12.3796 19.1102 10.5796C19.1102 5.1496 14.8413 0.745605 9.61033 0.745605C4.3794 0.745605 0.110474 5.17361 0.110474 10.5856C0.110474 15.9976 4.36737 20.4196 9.61033 20.4196C11.7628 20.4196 13.747 19.6756 15.3403 18.4276L21.3228 24.5776L23.9743 21.8356ZM9.61033 16.5556C6.44171 16.5556 3.86833 13.8796 3.86833 10.5856C3.86833 7.2916 6.44171 4.61561 9.61033 4.61561C12.7789 4.61561 15.3523 7.2916 15.3523 10.5856C15.3523 13.8796 12.7789 16.5556 9.61033 16.5556Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0503,
    height: 24,
    fill: "white",
    transform: "translate(0.050293 0.685547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.1d46ee6da54005629f73478a8802b972.svg";
export { ForwardRef as ReactComponent };